import { render, staticRenderFns } from "./TrainingQuestionsTable.vue?vue&type=template&id=e4732bde&scoped=true&"
import script from "./TrainingQuestionsTable.vue?vue&type=script&lang=js&"
export * from "./TrainingQuestionsTable.vue?vue&type=script&lang=js&"
import style0 from "./TrainingQuestionsTable.vue?vue&type=style&index=0&id=e4732bde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4732bde",
  null
  
)

export default component.exports